export default __webpack_public_path__ + "static/media/RobotoSlab-Bold.42bae56a.woff";